export default "__VITE_ASSET__CBhZOGmE__"